import LoginScreen from "./Components/LoginScreen";
import ReactTooltip from "react-tooltip";
import { useEffect } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import Context from "./Components/Context";
import ColorScheme from "./Components/ColorScheme";

function App() {
  useEffect(() => {
    let tooltipRefreshInterval = setInterval(() => {
      ReactTooltip.rebuild();
    }, 2000);

    return () => {
      clearInterval(tooltipRefreshInterval);
    };
  }, []);

  return (
    <div className="App">
      <Context>
        <ColorScheme />
        <Router>
          <LoginScreen />
        </Router>
        <ReactTooltip />
      </Context>
    </div>
  );
}

export default App;
